import {Injectable} from '@angular/core';


/**
 * Translations for lottery statuses.
 */
@Injectable()
export class LotteryStatusTranslationService {
  public i18nDraft: any = $localize`:@@general.text.draftMode:Draft Mode`;
  public i18nActivated: any = $localize`:@@general.text.activated:Activated`;
  public i18nEdit: any = $localize`:@@general.text.edit:Edit Mode`;
  public i18nInternal: any = $localize`:@@general.text.internal:Internal Mode`;
  public i18nCompleted: any = $localize`:@@general.text.completed:Completed`;
  public i18nPartlySeated: any = $localize`:@@general.text.partlySeated:Partly seated`;
  public i18nNothingSeated: any = $localize`:@@general.text.nothingSeated:Nothing seated`;
  public i18nCompletelySeated: any = $localize`:@@general.text.completelySeated:Completely seated`;
  public i18nExecution: any = $localize`:@@general.text.execution:Execution`;
  public i18nInProgress: any = $localize`:@@general.text.inProgress:In progress`;
  public i18nCreated: any = $localize`:@@general.text.created:Created`;
  public i18nPrimary: any = $localize`:@@general.text.primary:Primary`;
  public i18nSecondary: any = $localize`:@@general.text.secondary:Secondary`;

  constructor() { }
}
